<script>
import { layoutMethods } from "@/state/helpers";
import { obterClassePorLetra } from "@/helpers/common/api";
import { marcaState, assetUrl } from "@/services/marca";
import logoHorizontalPadrao from "@/assets/images/logo-pcdob-horizontal.png";
import logoIconePadrao from "@/assets/images/logo-pcdob-icon.png";
import TrocarSenhaModal from "@/components/crm/TrocarSenhaModal.vue";

const THEME_STORAGE_KEY = "app-theme-mode";

/**
 * Barra de navegacao superior generica.
 * Exibe logo, toggle dark-mode, fullscreen e menu do usuario.
 */
const TITULOS_MOBILE = {
  atendimento: 'Conversas',
  grupos: 'Grupos',
  canais: 'Notícias',
};

export default {
  components: { TrocarSenhaModal },
  data() {
    return {
      user: {},
      trocarSenhaAberto: false,
    };
  },

  computed: {
    // Logo e nome vindos da marca (whitelabel); fallback pro asset do bundle.
    logoHorizontal() {
      return marcaState.tem_logo_horizontal ? assetUrl("logo_horizontal") : logoHorizontalPadrao;
    },
    logoIcone() {
      // Mobile mostra o slot do ícone. Se não houver ícone custom mas houver
      // logo horizontal custom, usa ela (melhor que o ícone padrão do bundle).
      if (marcaState.tem_logo_icone) return assetUrl("logo_icone");
      if (marcaState.tem_logo_horizontal) return assetUrl("logo_horizontal");
      return logoIconePadrao;
    },
    marcaNome() {
      return marcaState.nome_curto || "PCdoB";
    },
    // Título da seção exibido no mobile (no lugar da logo). Dashboard/raiz = logo.
    tituloMobile() {
      const path = this.$route.path || '';
      if (path === '/' || path.startsWith('/app/dashboard')) return null;
      const m = path.match(/^\/app\/([^/]+)/);
      const secao = m ? m[1] : '';
      if (TITULOS_MOBILE[secao]) return TITULOS_MOBILE[secao];
      return (this.$route.meta && this.$route.meta.title) || null;
    },
  },

  methods: {
    obterClassePorLetra,
    ...layoutMethods,

    getUser() {
      this.user = JSON.parse(localStorage.getItem("userdata")) || {};
    },

    abrirTrocarSenha() {
      this.trocarSenhaAberto = true;
    },

    toggleHamburgerMenu() {
      const windowSize = document.documentElement.clientWidth;
      const hasVerticalSidebar = !!document.querySelector(".app-menu.navbar-menu");
      const layoutType = document.documentElement.getAttribute("data-layout")
        || (hasVerticalSidebar ? "vertical" : "horizontal");
      document.documentElement.setAttribute("data-sidebar-visibility", "show");
      const visibilityType = document.documentElement.getAttribute("data-sidebar-visibility");

      if (windowSize > 767) {
        const hamburger = document.querySelector(".hamburger-icon");
        if (hamburger) hamburger.classList.toggle("open");
      }

      // Collapse horizontal
      if (layoutType === "horizontal") {
        document.body.classList.toggle("menu");
      }

      // Collapse vertical / semibox
      if (visibilityType === "show" && (layoutType === "vertical" || layoutType === "semibox")) {
        if (windowSize < 1025 && windowSize > 767) {
          document.body.classList.remove("vertical-sidebar-enable");
          const size = document.documentElement.getAttribute("data-sidebar-size");
          document.documentElement.setAttribute("data-sidebar-size", size === "sm" ? "lg" : "sm");
        } else if (windowSize > 1025) {
          document.body.classList.remove("vertical-sidebar-enable");
          const size = document.documentElement.getAttribute("data-sidebar-size");
          document.documentElement.setAttribute("data-sidebar-size", size === "lg" ? "sm" : "lg");
        } else if (windowSize <= 767) {
          document.body.classList.add("vertical-sidebar-enable");
          document.documentElement.setAttribute("data-sidebar-size", "lg");
        }
      }

      // Two column
      if (layoutType === "twocolumn") {
        document.body.classList.toggle("twocolumn-panel");
      }
    },

    toggleMenu() {
      this.$parent.toggleMenu();
    },

    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    aplicarThemeColorPwa(mode) {
      const cor = mode === "dark" ? marcaState.cor_primaria_dark : marcaState.cor_primaria;
      let meta = document.querySelector('meta[name="theme-color"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "theme-color");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", cor);
    },

    toggleDarkMode() {
      const currentMode = document.documentElement.getAttribute("data-bs-theme") === "dark" ? "dark" : "light";
      const mode = currentMode === "dark" ? "light" : "dark";
      document.documentElement.setAttribute("data-bs-theme", mode);
      localStorage.setItem(THEME_STORAGE_KEY, mode);
      this.changeMode({ mode });
      this.aplicarThemeColorPwa(mode);
    },

    applyPersistedTheme() {
      const persistedMode = localStorage.getItem(THEME_STORAGE_KEY);
      const mode = persistedMode === "dark" ? "dark" : "light";
      document.documentElement.setAttribute("data-bs-theme", mode);
      this.changeMode({ mode });
      this.aplicarThemeColorPwa(mode);
    },
  },

  mounted() {
    this.getUser();
    this.applyPersistedTheme();

    document.addEventListener("scroll", function () {
      const pageTopbar = document.getElementById("page-topbar");
      if (pageTopbar) {
        document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50
          ? pageTopbar.classList.add("topbar-shadow")
          : pageTopbar.classList.remove("topbar-shadow");
      }
    });

  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="layout-width">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- Logo — substitua as imagens conforme o projeto -->
          <div class="navbar-brand-box horizontal-logo" :class="{ 'tem-titulo': tituloMobile }">
            <router-link to="/" class="logo logo-dark">
              <span class="logo-sm">
                <img :src="logoIcone" :alt="marcaNome" class="pcdob-logo-sm" />
              </span>
              <span class="logo-lg">
                <img :src="logoHorizontal" :alt="marcaNome" class="pcdob-logo-lg" />
              </span>
            </router-link>
            <router-link to="/" class="logo logo-light">
              <span class="logo-sm">
                <img :src="logoIcone" :alt="marcaNome" class="pcdob-logo-sm" />
              </span>
              <span class="logo-lg">
                <img :src="logoHorizontal" :alt="marcaNome" class="pcdob-logo-lg" />
              </span>
            </router-link>
          </div>

          <!-- Mobile: nome da seção no lugar da logo (exceto Dashboard). -->
          <div v-if="tituloMobile" class="topbar-mobile-title d-md-none">{{ tituloMobile }}</div>

          <button
            type="button"
            class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
            id="topnav-hamburger-icon"
            @click="toggleHamburgerMenu"
          >
            <span class="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>

        <div class="d-flex align-items-center">
          <!-- Fullscreen (desktop) -->
          <div class="ms-1 header-item d-none d-md-flex">
            <BButton
              type="button"
              variant="ghost-secondary"
              class="btn-icon btn-topbar rounded-circle"
              @click="initFullScreen"
            >
              <i class="bx bx-fullscreen fs-22"></i>
            </BButton>
          </div>

          <!-- Dark / Light toggle (sempre visível, ao lado dos 3 pontos no mobile) -->
          <div class="ms-1 header-item d-flex">
            <BButton
              type="button"
              variant="ghost-secondary"
              class="btn-icon btn-topbar rounded-circle light-dark-mode"
              @click="toggleDarkMode"
            >
              <i class="bx bx-moon fs-22"></i>
            </BButton>
          </div>

          <!-- Menu do usuario (desktop) -->
          <BDropdown
            variant="link"
            class="ms-sm-3 header-item topbar-user d-none d-md-flex"
            toggle-class="rounded-circle arrow-none"
            menu-class="dropdown-menu-end"
            :offset="{ alignmentAxis: -14, crossAxis: 0, mainAxis: 0 }"
          >
            <template #button-content>
              <span class="d-flex align-items-center">
                <div v-if="user.nome" class="avatar-group">
                  <BLink href="javascript: void(0);">
                    <div class="avatar-xxs">
                      <div :class="`avatar-title rounded-circle ${obterClassePorLetra(user.nome)}`">
                        {{ user?.nome?.substring(0, 1) }}
                      </div>
                    </div>
                  </BLink>
                </div>
                <span class="text-start ms-xl-2">
                  <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                    {{ user.nome }}
                  </span>
                  <span class="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                    {{ user.email }}
                  </span>
                </span>
              </span>
            </template>

            <h6 class="dropdown-header">Bem-vindo(a) {{ user.nome }}!</h6>
            <button type="button" class="dropdown-item" @click="abrirTrocarSenha">
              <i class="ri-lock-password-line text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Mudar senha</span>
            </button>
            <div class="dropdown-divider"></div>
            <router-link class="dropdown-item" to="/logout">
              <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Sair</span>
            </router-link>
          </BDropdown>

          <!-- Menu de 3 pontos (mobile) — alimentado no futuro -->
          <BDropdown
            variant="link"
            class="header-item d-md-none topbar-3pts"
            toggle-class="btn-icon btn-topbar rounded-circle arrow-none"
            menu-class="dropdown-menu-end"
          >
            <template #button-content>
              <i class="ri-more-2-fill fs-22"></i>
            </template>
            <h6 v-if="user.nome" class="dropdown-header text-truncate">{{ user.nome }}</h6>
            <button type="button" class="dropdown-item" @click="abrirTrocarSenha">
              <i class="ri-lock-password-line text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Mudar senha</span>
            </button>
            <div class="dropdown-divider"></div>
            <router-link class="dropdown-item" to="/logout">
              <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Sair</span>
            </router-link>
          </BDropdown>
        </div>
      </div>
    </div>

    <TrocarSenhaModal :visivel="trocarSenhaAberto" @fechar="trocarSenhaAberto = false" />
  </header>
</template>
